import {
  createMatchSelector,
  matchSelectorFn,
  RouterRootState,
} from 'connected-react-router';
import { State } from '../../reducers/State';
import { History } from 'history';

export const pathnameSelector = (state: State): string => {
  const pathname = state.router.location.pathname;
  // strip the trailing '/' off as long as it isn't just '/'
  if (pathname.length < 2) {
    return pathname;
  }
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

export const querySelector = (state: State): { [key: string]: string } => {
  return state.router.location.query;
};

const projectMatchSelector: matchSelectorFn<
  RouterRootState<History.UnknownFacade>,
  { projectName: string; organizationName: string; providerId: string }
> = createMatchSelector(
  `/dash/projects/:providerId([1-9])/:organizationName/:projectName([^/]+)`
);

export const isProjectLevelSelector = (state: State): boolean => {
  const match = projectMatchSelector(state);
  if (!match) {
    return false;
  }
  const { projectName, organizationName, providerId } = match.params;
  if (projectName && organizationName && providerId) {
    return true;
  }
  return false;
};

const organizationMatchSelector: matchSelectorFn<
  RouterRootState<History.UnknownFacade>,
  { dashPage: string; organizationName: string; providerId: string }
> = createMatchSelector(
  '/dash/:dashPage?/:providerId([1-9])/:organizationName'
);

export const isOrganizationLevelSelector = (state: State): boolean => {
  const match = organizationMatchSelector(state);
  const isProjectLevel = isProjectLevelSelector(state);
  if (!match || isProjectLevel) {
    return false;
  }
  const { dashPage, organizationName, providerId } = match.params;
  if (dashPage && organizationName && providerId) {
    return true;
  }
  return false;
};

export const projectNameFromRouteSelector = (state: State): string | null => {
  const match = projectMatchSelector(state);
  const projectName = match?.params?.projectName ?? null;
  return projectName && decodeURIComponent(projectName);
};

export const organizationNameFromRouteSelector = (
  state: State
): string | null => {
  const match = organizationMatchSelector(state);
  return match?.params?.organizationName ?? null;
};

export const providerIdFromRouteSelector = (state: State): string | null => {
  const match = organizationMatchSelector(state);
  return match?.params?.providerId ?? null;
};
